import Vue from 'vue'
import Vuex from 'vuex'
import common from 'gclife-common-front/lib/store'

// vuex State管理对象
const state = {
  dic: {},     // 字典
  btns: {}      // 按钮权限
}

// mutations事件， 由actions执行提交commit()
const mutations = {
  // 字典
  CHANG_DIC(state, dic) { state.dic = dic },
  // 按钮权限
  CHANG_BTNS(state, btns) { state.btns = btns }
}

// actions提交
const actions = {
  // 字典
  changDic({commit}, dic) { commit('CHANG_DIC', dic) },
  // 按钮权限
  changBtns({commit}, btns) { commit('CHANG_BTNS', btns) }
}

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    common
  },
  state,
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/store/index.js